import { createAction } from 'redux-actions';

import fetch from 'features/common/fetch';

import * as types from './actionTypes';
import { getOrganizationStructureChannels, getOrganizationStructureChannelsForSidebar } from './selectors';

const setChannels = createAction(types.FETCH_CHANNEL_SUCCESS, (values) => ({
	channels: values.map((channel) => ({
		...channel,
		id: Number(channel.id),
	})),
}));

const setEdkChannels = createAction(types.FETCH_EDK_CHANNEL_SUCCESS, (response) => ({
	channels: response.body.values,
}));

export const fetchIdkChannels =
	({ type, onSuccess, isGuarantor, customAllowedChannels }) =>
	(dispatch, getState) => {
		return dispatch(
			fetch.actions.get(fetch.constants.urls.orgStructureChannels, {
				uniqueReqID: type ? type : null,
				onSuccess: [
					(response) => () => {
						if (!response || !response.body) return;
						const values = response?.body?.values;
						dispatch(setChannels(values));

						const finalChannels =
							type === 'sidebar'
								? getOrganizationStructureChannelsForSidebar(
										getState(),
										isGuarantor,
										customAllowedChannels,
								  )
								: getOrganizationStructureChannels(getState(), isGuarantor);

						onSuccess(finalChannels);
					},
				],
			}),
		);
	};

export const fetchEdkChannels = (fetchSuffix) => (dispatch) => {
	return dispatch(
		fetch.actions.get(
			fetch.constants.urls.orgStructureEdkChannels,
			Object.assign({}, fetchSuffix ? { uniqueReqID: fetchSuffix } : null, { onSuccess: [setEdkChannels] }),
		),
	);
};
